<template>
    <v-container fluid class="ma-6 pa-6">
        <div class="instance-view">
            <create-instance
                ref="instanceDetails"
                :open="detailsOpened"
                @closeDialog="closeDialog"
                :instanceSelected="instanceSelected"
                :instances="instances"
                :modelisations="modelisations"
                :key="generateKey"
            ></create-instance>

            <form-create-app
                triggerComponent="app-btn"
                update
                :application="getCurrentApplication"
                @reloadApplication="reloadApplication"
            >
                <div slot="date"></div>
            </form-create-app>
            <ul>
                <li class="life-line create">
                    <v-container
                        class="container-no-spaces"
                    >
                        <v-row >
                            <v-col
                                cols="3"
                                sm="2"
                                md="2"
                            >
                                <create-btn
                                    :callback="openDialog"
                                    customClass="create-button-instance"
                                ></create-btn>
                            </v-col>

                            <v-col
                                cols="9"
                                sm="9"
                                md="2"
                                align-self="center"
                            >
                                <div>
                                    <v-tooltip right close-delay="2000">
                                      <template v-slot:activator="{ on }">
                                            <span>{{$t('instance.instance_list.index.create_new_instance')}}</span>
                                            <v-icon small dark v-on="on" color="#9e9e9e">info</v-icon>
                                        </template>
                                      <span><a href="#" style="color: white, font-size: 12px;">{{$t('instance.instance_list.create_instance.tooltip_tutorial')}}</a></span>
                                    </v-tooltip>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </li>
                <li
                    v-for="inst in instances"
                    :key="inst.uid"
                    class="life-line"
                >
                    <instance-item
                        :application="getCurrentApplication"
                        :instanceUid="inst.uid"
                        :modelisations="modelisations"
                        @toggleDialog="editInstance"
                    ></instance-item>
                </li>
                <li
                    v-if="instances.length === 0"
                    class="life-line"
                >
                    <v-alert
                        icon="warning"
                        color="grey lighten-5"
                        outlined
                        style="max-width: 500px; margin: 0;"
                    >
                        {{$t('instance.instance_list.index.no_instance_related')}}
                    </v-alert>
                </li>
            </ul>
        </div>
    </v-container>
</template>

<script>

import {
    mapGetters
} from 'vuex';
import AppBtn from '@/components/Partials/app-btn.vue';
import CreateBtn from '@/components/Partials/create-new-button.vue';
import InstanceItem from './instance-item.vue';
import FormCreateApp from '@/components/page/Application/form-create-app.vue';
import createInstance from './create-instance.vue';

export default {

    components: {
        AppBtn,
        CreateBtn,
        InstanceItem,
        FormCreateApp,
        createInstance

    },

    props: {
        instances: {
            type: Array,
            required: true,
        },
        modelisations: {
            type: Array,
            required: true,
        },
    },

    data (){
        return {
            detailsOpened: false,
            instanceSelected: {},
        };
    },

    computed: {
        ...mapGetters([
            'getCurrentApplication'
        ]),
        generateKey() {
            return this.instanceSelected.uid;
        }
    },

    created (){
    },

    methods: {
        reloadApplication(app) {
            this.$store.commit('SET_CURRENT_APPLICATION', app);
        },
        openDialog() {
            this.$refs.instanceDetails.resetForm();
            this.detailsOpened = true;
        },
        editInstance(instance) {
            if(instance.deployment_status === 'DEPLOYING') return;
            this.instanceSelected = instance;
            this.detailsOpened = true;
        },
        closeDialog(refresh) {
            this.instanceSelected = {};
            this.detailsOpened = false;
            if (refresh) {
                this.$emit('triggerRefresh');
            }
        }
    },
};
</script>

<style lang="scss">
.instance-view {
    .create-button-instance {
        width: 70px !important;
        height: 70px !important;
        min-width: 70px;
        max-width: 70px;
        transform: rotateZ(45deg);

        i {
            transform: rotateZ(45deg);
        }

    }

    ul {
        padding: 0;

        .container-no-spaces{
            padding: 0;
            margin: 0;
        }
        .life-line {
            list-style: none;
            padding-left: 125px;
            position: relative;
            min-height: 125px;
            &:not(.create){

                @media screen and (max-width: 960px){
                    min-height: 245px;
                }
            }

            &:not(:nth-of-type(2)):before {
                @media screen and (max-width: 960px){
                    top: -205px;
                    height: 245px;
                }
            }
            &:before {
                position: absolute;
                top: -100px;
                left: 50px;
                height: 142px;
                content: "";
                width: 1px;
                border: 1px solid grey;

            }

            &:after {
                position: absolute;
                top: 40px;
                left: 50px;
                height: 1px;
                content: "";
                width: 61px;
                border: 1px solid grey;
            }

            .instance-btn-content {
                transform: rotateZ(-45deg);
                font-size: 25px;
                font-weight: bold;
            }

            .instance-url {
                font-size: 32px;
            }

            .instance-status {
                text-transform: uppercase;
                font-size: 10.5px;
            }
            
        }
        .tooltip-text-color a{
            color: white;
        }

        .life-line.create {
            &:before {
                position: absolute;
                top: 0;
                left: 50px;
                height: 150px;
                content: "";
                width: 1px;
                border: 1px solid grey;
            }

            &:after {
                position: absolute;
                top: 40px;
                left: 50px;
                height: 1px;
                content: "";
                width: 61px;
                border: 1px solid grey;
            }

            .add-instance-text{
                font-size: 14px;
                color: #b8b8b8;
                margin-top: 15px;
            }
        }

    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/InstanceList/index.vue